import { defaultTo } from 'lodash';
import { IModel, Model } from './Model';
import { ITraitModel, TraitModel } from './TraitModel';

export interface IModelWithTrait extends IModel {
  traitId: number;
  stringValue: string | undefined;
  numberValue: number | undefined;
  decimalValue: number | undefined;
  boolValue: boolean | undefined;
  extendedValue: string | undefined;
  trait: ITraitModel;
}

export class ModelWithTrait
  extends Model
  implements Record<keyof IModelWithTrait, any>
{
  traitId: number;
  stringValue: string | undefined;
  numberValue: number | undefined;
  decimalValue: number | undefined;
  boolValue: boolean | undefined;
  extendedValue: string | undefined;
  trait: TraitModel;

  constructor(params: Partial<IModelWithTrait>) {
    super(params);
    this.traitId = defaultTo(params.traitId, 0);
    this.stringValue = params.stringValue;
    this.numberValue = params.numberValue;
    this.decimalValue = params.decimalValue;
    this.boolValue = params.boolValue;
    this.extendedValue = params.extendedValue;
    this.trait = new TraitModel(defaultTo(params.trait, {}));
  }
}
